// js/utils/formatters.js
export const formatCPF = (cpf = '') =>
    (cpf || '').replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4');

export const formatPhone = (phone = '') => {
    // Remover todos os caracteres não numéricos
    let d = (phone || '').replace(/\D/g, '');
    
    // Remover o código do país (55) se estiver presente no início
    if (d.startsWith('55') && d.length >= 12) {
        d = d.substring(2); // Remove os primeiros 2 dígitos (55)
    }
    
    // Limitar a 11 dígitos (DDD + número)
    d = d.substring(0, 11);
    
    // Formatar conforme o tamanho
    if (d.length >= 11) {
        // Celular: (XX) XXXXX-XXXX
        return d.replace(/(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
    } else if (d.length >= 10) {
        // Telefone fixo: (XX) XXXX-XXXX
        return d.replace(/(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3');
    } else if (d.length >= 6) {
        // Parcial: (XX) XXXX...
        return d.replace(/(\d{2})(\d{0,5})/, '($1) $2');
    } else if (d.length >= 2) {
        // Apenas DDD: (XX)
        return d.replace(/(\d{2})/, '($1)');
    }
    
    return d;
};

export const formatDateBR = (date = '') =>
    date ? new Date(`${date}T00:00:00`).toLocaleDateString('pt-BR') : '';
